import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { AttendeeFields } from '@/types/all-attendees.types';

export const setListAttendeesFields = (create: ReducerCreators<AudiencesState>) =>
  create.reducer<AttendeeFields>((state, action) => {
    state.listAttendees.fields = action.payload;
    state.listAttendees.page = 1;
  });
